import { render, staticRenderFns } from "./WorkStationAddNew.vue?vue&type=template&id=523067f2"
import script from "./WorkStationAddNew.vue?vue&type=script&lang=js"
export * from "./WorkStationAddNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports